import { render, staticRenderFns } from "./EducationalItemSelectionModal.vue?vue&type=template&id=425b4633&"
import script from "./EducationalItemSelectionModal.vue?vue&type=script&lang=js&"
export * from "./EducationalItemSelectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports